<template>
  <v-container fluid grid-list-md>
    <v-card class="mb-2">
      <v-card-title>
        <span class="headline mb-0">納入場所詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_WS_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-form v-model="valid">
      <v-layout row style="margin-top: 24px !important" wrap>
        <v-flex md6 sm12 style="padding: 0px !important; padding-right: 10px">
          <v-card>
            <v-card-text>
              <v-container fluid style="padding: 17px !important">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      :disabled="$route.path.indexOf('new') === -1"
                      :rules="codeRules"
                      clearable
                      label="納入場所CD"
                      v-model.trim="warehouse.code"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="calendarType"
                      :rules="calendarRules"
                      clearable
                      label="カレンダー区分"
                      v-model="warehouse.calendarType"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="$t('app.warehouseTypes')"
                      :rules="typeRules"
                      clearable
                      label="納入場所区分"
                      v-model="warehouse.type"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :rules="nameRules"
                      clearable
                      label="納入場所名"
                      v-model="warehouse.name"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :rules="nameCNRules"
                      clearable
                      label="漢字名称"
                      v-model="warehouse.chineseName"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :rules="nameShortRules"
                      clearable
                      label="表示略称"
                      v-model="warehouse.nickname"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      clearable
                      label="英字名称"
                      v-model="warehouse.englishName"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      clearable
                      label="カナ名称"
                      v-model="warehouse.kanaName"
                    />
                  </v-flex>
                  <!-- <v-autocomplete
                :items="BUs"
                clearable
                item-text="displayText"
                label="所属事業本部"
                v-if="warehouse.type"
                v-model="warehouse.buId"
                  />-->
                  <v-flex xs12>
                    <remote-autocomplete
                      clearable
                      label="グループ"
                      url="warehouse-groups/kv"
                      v-model="warehouse.groupId"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :rules="addressRules"
                      clearable
                      label="住所"
                      v-model="warehouse.address"
                    />
                  </v-flex>
                  <!--
              <v-autocomplete
                :items="warehouseManagers"
                :rules="responsible1Rules"
                itemText="displayText"
                itemvalue="value"
                label="倉庫担当1"
                v-model="warehouse.warehouseManager1Id"
              />
              <v-autocomplete
                :items="warehouseManagers"
                itemText="displayText"
                itemvalue="value"
                label="倉庫担当2"
                v-model="warehouse.warehouseManager2Id"
              />
              <v-autocomplete
                :items="warehouseManagers"
                itemText="displayText"
                itemvalue="value"
                label="倉庫担当3"
                v-model="warehouse.warehouseManager3Id"
              />
                  -->
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          md6
          sm12
          style="padding: 0px !important"
          v-if="warehouse.type === 'SC'"
        >
          <ref-warehouses v-model="warehouse.mappings" />
        </v-flex>
        <v-flex
          md6
          sm12
          style="padding: 0px !important"
          v-if="warehouse.type === 'SJL'"
        >
          <v-card>
            <v-card-text>
              <v-container fluid style="padding: 17px !important">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select
                      :items="$t('app.finalWarehouseTypes')"
                      clearable
                      label="最終納入場所区分"
                      v-model="warehouse.finalWarehouseType"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <remote-autocomplete
                      clearable
                      label="紐付単価用納入場所"
                      url="warehouses/fee-kv"
                      v-model="warehouse.refChargeWarehouseId"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="$t('app.unPackingObjs')"
                      clearable
                      label="デバン対象"
                      v-model="warehouse.canAsDevanPort"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="warehouseManagers"
                      clearable
                      itemText="displayText"
                      itemvalue="value"
                      label="受入確認担当1"
                      v-model="warehouse.receiveManager1Id"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="warehouseManagers"
                      clearable
                      itemText="displayText"
                      itemvalue="value"
                      label="受入確認担当2"
                      v-model="warehouse.receiveManager2Id"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="warehouseManagers"
                      clearable
                      itemText="displayText"
                      itemvalue="value"
                      label="受入確認担当3"
                      v-model="warehouse.receiveManager3Id"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="warehouseManagers"
                      clearable
                      itemText="displayText"
                      itemvalue="value"
                      label="受入確認担当4"
                      v-model="warehouse.receiveManager4Id"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="warehouseManagers"
                      clearable
                      itemText="displayText"
                      itemvalue="value"
                      label="受入確認担当5"
                      v-model="warehouse.receiveManager5Id"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="warehouseManagers"
                      clearable
                      itemText="displayText"
                      itemvalue="value"
                      label="納入場所担当１"
                      v-model="warehouse.warehouseManager1Id"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="warehouseManagers"
                      clearable
                      itemText="displayText"
                      itemvalue="value"
                      label="納入場所担当2"
                      v-model="warehouse.warehouseManager2Id"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="warehouseManagers"
                      clearable
                      itemText="displayText"
                      itemvalue="value"
                      label="納入場所担当3"
                      v-model="warehouse.warehouseManager3Id"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="warehouseManagers"
                      clearable
                      itemText="displayText"
                      itemvalue="value"
                      label="納入場所担当4"
                      v-model="warehouse.warehouseManager4Id"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="warehouseManagers"
                      clearable
                      itemText="displayText"
                      itemvalue="value"
                      label="納入場所担当5"
                      v-model="warehouse.warehouseManager5Id"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox
                      label="受入確認必要"
                      v-model="warehouse.acceptable"
                    ></v-checkbox>
                    <v-checkbox
                      label="コンテナ受入枠で管理"
                      v-model="warehouse.reservable"
                    ></v-checkbox>
                    <v-checkbox
                      label="仮想倉庫"
                      v-model="warehouse.virtualWarehouse"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
          <calendar class="mt-2" v-model="warehouse.dailySettings" />
          <products class="mt-2" v-model="warehouse.productSettings" />
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
/* eslint-disable no-console */
import Calendar from "./Calendar";
import Products from "./Products";
import RefWarehouses from "./RefWarehouses";
export default {
  components: {
    Calendar,
    Products,
    RefWarehouses,
  },
  data() {
    return {
      picker: "",
      valid: true,
      calendarType: [
        {
          text: "基本カレンダー",
          value: "BASIC_CALENDAR",
        },
        {
          text: "稼働日カレンダー",
          value: "WORKING_CALENDAR",
        },
      ],
      BUs: [],
      warehouseManagers: [],
      limit: null,
      warehouse: {
        productSettings: [],
        dailySettings: [],
        mappings: [],
        acceptable: false,
      },
      selected: [],
      items: [],

      codeRules: [(v) => !!v || "納入場所CD is required"],
      calendarRules: [(v) => !!v || "カレンダー区分 is required"],
      typeRules: [(v) => !!v || "納入場所区分 is required"],
      nameRules: [(v) => !!v || "納入場所区分 is required"],
      nameCNRules: [(v) => !!v || "漢字名称 is required"],
      nameShortRules: [(v) => !!v || "表示略称 is required"],
      groupRules: [(v) => !!v || "グループ is required"],
      addressRules: [(v) => !!v || "住所 is required"],
      responsible1Rules: [(v) => !!v || "倉庫担当1 is required"],
      errors: {
        CODE_EXISTS: "既存CDと重複したので、内容を変更してください。",
      },
    };
  },
  methods: {
    loadKV() {
      this.$http
        .get("/divisions/kv", {
          params: {
            type: "BU",
          },
        })
        .then((res) => {
          this.BUs = res.data.map((d) => ({
            ...d,
            displayText: d.code + (d.text ? " [" + d.text + "]" : ""),
          }));
        });
      this.$http.get("/employees/kv").then((res) => {
        this.warehouseManagers = res.data.map((d) => ({
          ...d,
          displayText: d.code + (d.text ? " [" + d.text + "]" : ""),
        }));
      });
    },
    save() {
      this.$http
        .post("/warehouses", this.warehouse)
        .then(() => {
          this.$http
            .post("purchase-orders/po-warehouse", this.warehouse)
            .then(() => this.$router.go(-1))
            .catch((err) => {
              this.$showError(err);
            });
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
    initData() {
      this.warehouse.code = this.$route.query.code;
      this.warehouse.name = this.$route.query.name;
    },
  },
  mounted() {
    this.loadKV();
    this.initData();
  },
};
</script>
